/* host-mode.js — single-domain mode (iter98.82 simplification).
 *
 * Previously this module supported a split deploy:
 *   • Marketing on invisique.in / www.invisique.in
 *   • Portals on my.invisique.in
 *
 * Emergent's deployment platform supports only ONE custom domain per
 * deployment (confirmed by Emergent Support 2026-02-15), which means
 * the split-host design isn't practical without a second deployment.
 * Per user decision, we collapse everything onto the single linked
 * domain (`invisique.in`).
 *
 * This file is now a permanent compatibility shim so every existing
 * import keeps working without a callsite refactor:
 *
 *   • `getHostMode()`     → always "both"
 *   • `isPortalMode()`    → false  (we no longer "are on" the portal host)
 *   • `isMarketingMode()` → false
 *   • `isUniversalMode()` → true   (single domain = render everything)
 *   • `portalUrl(p)`      → relative path, no origin hop
 *   • `marketingUrl(p)`   → relative path, no origin hop
 *
 * The Route gates in App.js read `mode === "both"` so leaving them in
 * place is harmless — they always evaluate true. Callers of the URL
 * helpers stay on the same origin.
 */

export function getHostMode() {
    return "both";
}

export const isPortalMode = () => false;
export const isMarketingMode = () => false;
export const isUniversalMode = () => true;

/* Both helpers now return the path verbatim — single domain, no
 * cross-origin navigation. Accepts a fully-qualified URL and passes
 * it through unchanged (some callsites pass external HTTPS URLs). */
function _normalise(path) {
    if (!path) return "/";
    if (/^https?:\/\//i.test(path)) return path;
    return path.startsWith("/") ? path : `/${path}`;
}

export function portalUrl(path)   { return _normalise(path); }
export function marketingUrl(path) { return _normalise(path); }
